import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import { connect } from 'react-redux'
import { dispatch, RootState, select, store } from '../../store'
import Avatar from '../Avatar'
import { CardContainer } from '../Card'
import Icon from '../Icon'
import styles from './profile-card.scss'


const cx = classnames.bind(styles)

interface IProps extends React.HTMLProps<HTMLDivElement> {
  userId: string
  theme: string
  deviceType: string
  onEdit: () => void
}

class ProfileCard extends React.Component<IProps> {
  public fetchData = (props: IProps) => {
    const rootState = store.getState()
    const { userId } = props
    const user = select.users.getById(rootState, userId)
    if (user === null) {
      dispatch.users.fetchUsers([userId])
    }
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    if (nextProps.userId !== this.props.userId) {
      this.fetchData(nextProps)
    }
  }
  public componentDidMount = () => {
    this.fetchData(this.props)
  }
  public render() {
    const { className, userId, theme, deviceType, onEdit } = this.props
    const rootState = store.getState()
    const user = select.users.getById(rootState, userId)
    const currentUser = firebase.auth().currentUser
    return (
      <CardContainer className={cx('profile-card', className)}>
        <Avatar className={cx('profile-card__avatar')} userId={userId} />
        <div className={cx('profile-card__content')}>
          <div className={cx('profile-card__lecturer')}>
            <h2 className={cx('name')}>{user ? user.fullName : 'N/A'}</h2>
            <p className={cx('title')}>{user ? user.title : 'N/A'}</p>
            {
              currentUser && userId === currentUser.uid ? (
                <div onClick={onEdit} className={cx('btn', `btn--${theme}`, `btn--${deviceType}`)} >
                  編輯個人資料
              </div>
              ) : null
            }
          </div>
          <div className={cx('profile-card__about')}>
            <p>{user ? user.description : 'N/A'}</p>
          </div>
          <ul className={cx('profile-card__work')}>
            {
              user ? user.jobs.map((job, idx) => (
                <li key={idx} className={cx('item')}>
                  <Icon className={cx('icon')} type="work-experience" />
                  <span>
                    <span>{job.organization}</span>&#32;
                    <span>{job.title}</span>
                  </span>
                </li>
              )) : null
            }
          </ul>
        </div>
      </CardContainer>
    )
  }
}

const mapState = ({ users }: RootState) => ({ users })
export default connect(mapState)(ProfileCard)



// WEBPACK FOOTER //
// ./src/components/ProfileCard/index.tsx